module.exports = __webpack_public_path__ + "static/media/teton.941c1901.jpeg";